import { useEffect, useState, useRef } from "react";

function AdminPage() {
  const [products, setProducts] = useState([]);
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("women");
  const [inStock, setInStock] = useState(true);
  const [featured, setFeatured] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [image, setImage] = useState([]);
  const [sizes, setSizes] = useState("");
  const [colors, setColors] = useState("");
  const fileInputRef = useRef(null);
  const [fileInputKey, setFileInputKey] = useState(0);

  useEffect(() => {
    async function fetchData() {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/api/products`);
      const products = await data.json();
      setProducts(products);
    }
    fetchData();
  }, []);

  function handleEdit(product) {
    setEditingId(product.id);
    setName(product.name);
    setPrice(product.price);
    setCategory(product.category);
    setInStock(product.inStock);
    setFeatured(product.featured);
    setSizes(product.sizes || "");
    setColors(product.colors || "");
  }

  async function handleDelete(id) {
    await fetch(`${process.env.REACT_APP_API_URL}/api/products/${id}`, {
      method: "DELETE",
    });
    setProducts(products.filter((product) => product.id !== id));
  }

  function resetForm() {
    setEditingId(null);
    setName("");
    setPrice("");
    setCategory("women");
    setSizes("");
    setColors("");
    setInStock(true);
    setFeatured(false);
    setImage([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
    setFileInputKey((prev) => prev + 1); // Reset file input
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("price", price);
    formData.append("sizes", sizes);
    formData.append("colors", colors);
    formData.append("category", category);
    formData.append("inStock", inStock);
    formData.append("featured", featured);
    image.forEach((file) => formData.append("images", file));

    if (editingId) {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/products/${editingId}`,
        {
          method: "PUT",
          body: formData,
        },
      );
      const updated = await response.json();
      setProducts(products.map((p) => (p.id === editingId ? updated : p)));
    } else {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/products`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setProducts([...products, data]);
    }

    resetForm();
  }

  return (
    <div className="admin-container">
      <h2>Admin Page</h2>
      {products.map((product) => (
        <div key={product.id} className="admin-product-row">
          <p>
            {product.name} - ${product.price} - {product.category}
          </p>
          <div className="admin-row-buttons">
            <button className="edit-btn" onClick={() => handleEdit(product)}>
              Edit
            </button>
            <button
              className="delete-btn"
              onClick={() => handleDelete(product.id)}
            >
              Delete
            </button>
          </div>
        </div>
      ))}
      <form onSubmit={handleSubmit} className="admin-form">
        <h3>{editingId ? "Edit Product" : "Add New Product"}</h3>
        <label>
          Name:
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </label>
        <label>
          Price:
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </label>
        <label>
          Category:
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="women">Women</option>
            <option value="kids">Kids</option>
          </select>
        </label>
        <label>
          Sizes (comma separated):
          <input
            type="text"
            value={sizes}
            onChange={(e) => setSizes(e.target.value)}
            placeholder="XS, S, M, L, XL"
          />
        </label>
        <label>
          Colors (comma separated):
          <input
            type="text"
            value={colors}
            onChange={(e) => setColors(e.target.value)}
            placeholder="Black, White, Beige"
          />
        </label>
        <label>
          In Stock:
          <input
            type="checkbox"
            checked={inStock}
            onChange={(e) => setInStock(e.target.checked)}
          />
        </label>
        <label>
          Featured:
          <input
            type="checkbox"
            checked={featured}
            onChange={(e) => setFeatured(e.target.checked)}
          />
        </label>
        <label>
          Images:
          <input
            key={fileInputKey}
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={(e) =>
              setImage((prev) => [...prev, ...Array.from(e.target.files)])
            }
          />
        </label>
        {image.length > 0 && (
          <div className="selected-images">
            {image.map((file, index) => (
              <div key={index} className="selected-image-item">
                <span>{file.name}</span>
                <button
                  type="button"
                  onClick={() => {
                    setImage(image.filter((_, i) => i !== index));
                    setFileInputKey((prev) => prev + 1);
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}
        <div className="form-buttons">
          {editingId && (
            <button className="admin-btn" type="button" onClick={resetForm}>
              Cancel
            </button>
          )}
          <button type="submit" className="admin-btn">
            {editingId ? "Update Product" : "Add Product"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AdminPage;
